import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Link } from 'react-router';
import moment from 'moment';

import { toSlug } from 'utils';

import {localTimeShort} from 'utils/LocalDateTimeHelper';

export default class HorseRacingEarlyEntriesListItem extends Component {
  static propTypes = {
    meetingSummary: PropTypes.shape({
      course: PropTypes.shape({
        name: PropTypes.string.isRequired
      }),
      date: PropTypes.string.isRequired
    }),
    races: PropTypes.arrayOf(PropTypes.object)
  };

  render() {
    const {
      meetingSummary: {
        course: {
          name: courseName = "Unknown"
        } = {},
        date: uncheckedMeetingDate
      } = {},
      races = []
    } = this.props;

    const sortedRaces = races.sort((a, b) => a.time > b.time);
    const meetingDate = uncheckedMeetingDate ? moment(uncheckedMeetingDate, "YYYY-MM-DD").format('ddd MMMM DD YYYY') : "Unknown"

    return (
      <div className="early-entries-meeting">
        <div className="early-entries-meeting-header">
          <div className="early-entries-meeting-header-title">{ meetingDate } - { courseName }</div>
        </div>
        <ul className="early-entries-meeting-races">
          {
            sortedRaces.map(({
              date: raceDate,
              course_name: courseName,
              race_summary_reference: {
                id: raceId
              } = {},
              name: raceName = 'Unknown',
              time: raceTime
            }) => {
              const raceMeetingDate = moment(raceDate).format('YYYY-MM-DD');
              const raceCourseName = toSlug(courseName);
              const londonRaceTime = localTimeShort(`${raceDate}T${raceTime}Z`);
              return (
                <li key={`${raceId}`}>
                  <Link to={`/racing/racecards/${raceMeetingDate}/${raceCourseName}/racecard/${raceId}/${toSlug(raceName)}`}>
                    <span className='early-entries-meeting-content-race-time'>{ londonRaceTime }</span>
                    <span className='early-entries-meeting-content-race-name'>{ raceName }</span>
                  </Link>
                </li>
              );
            })
          }
        </ul>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/components/HorseRacingEarlyEntriesListItem.js